module.exports = __webpack_public_path__ + "img/item1.9721ed2a.png";